export default `float de(vec3 p){
    float radius = 1.;
    const float q = 2.61803398875;  
    const vec3 n1 = normalize(vec3(q,1.0,0.0));
    const vec3 n2 = vec3(0.57735026919);  

    p = abs(p / radius);
    float a = dot(p, n1.xyz);
    float b = dot(p, n1.zxy);
    float c = dot(p, n1.yzx);
    float d = dot(p, n2) - n1.x;
    return max(max(max(a,b),c)-n1.x,d) * radius;
  }`